import {
  ComponentsOverrides,
  ComponentsProps,
  ComponentsVariants,
  Theme,
} from '@mui/material';
import { tannerSemantic, tannerWhite } from '../colors';

type MuiLink = {
  styleOverrides?: ComponentsOverrides<Theme>['MuiLink'];
  defaultProps?: ComponentsProps['MuiLink'];
  variants?: ComponentsVariants['MuiLink'];
};

export const MuiLink: MuiLink = {
  defaultProps: {
    underline: 'none',
  },
  styleOverrides: {
    root: {
      fontSize: '14px',
      lineHeight: '20px',
      color: tannerSemantic.info.color,
      '&.MuiTypography-colorPrimary': {
        color: '#0066ED',
      },
      '&:hover': {
        color: tannerSemantic.info.color,
        textDecoration: 'underline',
      },
      '&:active': {
        color: tannerSemantic.info.color,
      },
      '&:Mui-focusVisible': {
        outline: '2px solid' + tannerSemantic.info.color,
        border: `3px solid ${tannerWhite}`,
      },
      '&[disabled]': {
        color: tannerSemantic.info.color,
        cursor: 'default',
        opacity: 0.3,
        pointerEvents: 'none',
      },
      '& svg': {
        fill: 'currentColor',
        height: '16px',
        width: '16px',
      },
    },
  },
};
